import { render, staticRenderFns } from "./ConsigneeInformation.vue?vue&type=template&id=6cd8a1b8&"
import script from "./ConsigneeInformation.vue?vue&type=script&lang=js&"
export * from "./ConsigneeInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\agent\\_work\\11\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cd8a1b8')) {
      api.createRecord('6cd8a1b8', component.options)
    } else {
      api.reload('6cd8a1b8', component.options)
    }
    module.hot.accept("./ConsigneeInformation.vue?vue&type=template&id=6cd8a1b8&", function () {
      api.rerender('6cd8a1b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business-orders/ConsigneeInformation.vue"
export default component.exports